// extracted by mini-css-extract-plugin
export var content = "UserVerificationResend-module--content--0f0c0";
export var formWrapper = "UserVerificationResend-module--formWrapper--5d267";
export var header = "UserVerificationResend-module--header--06cb7";
export var submitButton = "UserVerificationResend-module--submitButton--9d3f6";
export var wrapper = "UserVerificationResend-module--wrapper--0df7d";